import React from 'react';

// Feature Card Component
const FeatureCard = ({ icon, title, description, onClick }) => {
  return (
    <div 
      onClick={onClick}
      className="bg-stone-800 p-4 rounded-lg shadow-md text-center cursor-pointer hover:bg-stone-700 transition-colors"
    >
      <div className="flex justify-center mb-2 text-amber-400">
        {icon}
      </div>
      <h3 className="text-amber-300 font-bold mb-1">{title}</h3>
      <p className="text-amber-100 text-xs">{description}</p>
    </div>
  );
};

export default FeatureCard;